import { useMemo } from "react";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { getLatestShippingAgencyTransfer } from "@services/shippingAgencyTransferApi";
import { getVesselCallById } from "@services/vesselCallApi";
import { useQuery } from "@tanstack/react-query";
import { SHIPPING_AGENCY_TRANSFER_STATUS } from "../ShippingAgencyTransfer/flow/utils";

const SERVICE = "bff-vessel-call";

export const useCheckProposedAgency = (vesselCallId: string, enabled = true): boolean => {
  const { user } = useAuthStore();
  const isEnabled = enabled && !!vesselCallId;

  const { data: vesselCallDetails } = useQuery({
    queryKey: ["vesselCallDetails", vesselCallId],
    queryFn: () => getVesselCallById(SERVICE, vesselCallId),
    enabled: isEnabled,
  });

  const { data: latestTransfer, isError: isTransfersError } = useQuery({
    queryKey: ["getLatestShippingAgencyTransfer", vesselCallId],
    queryFn: () =>
      getLatestShippingAgencyTransfer(SERVICE, {
        vesselCallId,
      }),
    enabled: isEnabled && !!vesselCallDetails?.vesselId,
  });

  const hasPendingTransfer =
    latestTransfer?.status === SHIPPING_AGENCY_TRANSFER_STATUS.PENDING_APPROVAL ||
    latestTransfer?.status === SHIPPING_AGENCY_TRANSFER_STATUS.PENDING_MARINE_DEPARTMENT_APPROVAL;

  const isProposedAgency = useMemo(() => {
    if (!isEnabled || !user || !vesselCallDetails || isTransfersError) return false;
    return hasPendingTransfer && latestTransfer?.newShippingAgency?.companyCode === user.companyId;
  }, [isEnabled, vesselCallDetails, hasPendingTransfer, latestTransfer, user, isTransfersError]);

  return isProposedAgency;
};
